export const ArticleDefaultValue: IArticle["get"] = {
    id: 0,
    title: "",
    brief: "",
    thumbnail: "",
    banner: "",
    url: "",
    body: "",
    isPublish: false,
    tags: [],
    views: 0,
    seoDescription: "",
    seoKeywords: "",
    updateDateTime: "",
    createDateTime: "",
};
